<style scoped>
    .wrap{
        padding: 20px;
    }
    .label{
        position: relative;
        float: left;
        display: inline-block;
        vertical-align: top;
        width: 30px;
        padding-right: 6px;
        text-align: right;
        color: #888;
    }
    .label:before{
        content: ':';
        position: absolute;
        top: 0;
        right: 0;
    }
    .value{
        padding-left: 35px;
        white-space: normal;
    }
    .user-flow{
        margin-top: 20px;
    }
    .user-flow .value{
        padding-top: 3px;
        padding-left: 45px;
    }
    .tag{
        margin-right: 5px;
    }
</style>
<template>
    <div class="wrap">
        <h2 class="text-center">{{wiki.name}}</h2>
        <div v-if="wiki.id">
            <div class="line" v-if="wiki.tags && wiki.tags.length">
                <div class="label">标签</div>
                <div class="value">
                    <span class="tag" v-for="tag in wiki.tags" :key="tag.id">{{tag.name}}</span>
                </div>
            </div>
            <div class="line">
                <div class="label">内容</div>
                <div class="value">
                    <div v-html="wiki.content"></div>
                </div>
            </div>
            <div class="line">
                <div class="label">附件</div>
                <div class="value" v-if="wiki.files.length">
                    <Attachments :files="wiki.files"></Attachments>
                </div>
                <div class="value" v-else>无</div>
            </div>
        </div>
        <div class="text-center" v-else>
            <Spin size="large" fix></Spin>
        </div>
    </div>
</template>
<script>
    import ViewerItem from '../item';
    import Attachments from '../../../components/file/attachments';
    export default {
        components: { ViewerItem, Attachments },
        props: {
            model_id: {
                type: Number
            }
        },
        data(){
            return {
                wiki: {}
            }
        },
        computed: {
            //
        },
        created(){
            this.getWiki();
        },
        mounted(){
            //
        },
        methods: {
            getWiki(){
                Util.ajax.get(Util.api.wiki_detail, {
                    params: {
                        id: this.model_id
                    }
                }).then((response)=>{
                    return response.data;
                }).then((res)=>{
                    if(res.code === 1){
                        this.wiki = res.data.wiki;
                    }else{
                        this.$Modal.error({
                            title: '错误',
                            content: res.msg
                        });
                    }
                }).catch((e)=>{
                    console.log(e);
                    this.$Modal.error({
                        title: '错误',
                        content: e.message
                    });
                });
            }
        }
    }
</script>
